import { createSlice } from '@reduxjs/toolkit';
import {
  addEquipment,
  fetchEquipments,
  fetchEquipmentsByGeneration,
  removeEquipment,
  editEquipment,
} from '../actions/vehicleEquipments-actions';
import { Status } from '../../helpers/consts/status';

const initialState = {
  isLoading: false,
  equipments: [],
  filteredEquipments: [],
  count: 0,
};

const equipmentsSlice = createSlice({
  name: 'vehicleEquipments',
  initialState: initialState,
  reducers: {
    resetEquipments(state) {
      console.log('poziva')
      state.equipments = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchEquipments.pending, (state, action) => {
        state.status = Status.LOADING;
      })
      .addCase(fetchEquipments.fulfilled, (state, action) => {
        const equipments = action.payload;
        state.equipments = equipments;
        state.isLoading = false;
        //state.status = Status.COMPLETED;
      })
      .addCase(fetchEquipments.rejected, (state, action) => {})
      .addCase(fetchEquipmentsByGeneration.fulfilled, (state, action) => {
        const equipments = action.payload;
        state.filteredEquipments = equipments;
        state.isLoading = false;
       // state.status = Status.COMPLETED;
      })
      .addCase(addEquipment.fulfilled, (state, action) => {
        const newEquipment = action.payload;
        state.equipments.push(newEquipment);
      })
      .addCase(editEquipment.fulfilled, (state, action) => {
        const data = action.payload;
        const index = state.equipments.findIndex(
          (equipment) => equipment.id === data.id
        );
        if (~index) {
          state.equipments[index] = data;
        }
      })
      .addCase(removeEquipment.fulfilled, (state, action) => {
        const equipmentId = action.payload;
        console.log(action.payload);

        state.equipments = state.equipments.filter(
          (equipment) => equipment.id !== equipmentId
        );
      });
  },
});

export const equipmentsActions = equipmentsSlice.actions;
export const { resetEquipments } = equipmentsSlice.actions;


export default equipmentsSlice;
